import BackgroundChart from './BackgroundChart'

export default BackgroundChart
